<template>
  <page>
    <template slot="content">
        <template>
          <list-group>
            <div class="padding-top">
              <h2 class="title-h2">よくある質問<br><span class="title-span">FAQ</span></h2>
            </div>
            <div class="faq-container">
              <div class="faq-area" v-for="(item, index) in faq_items" :key="index">
                <ListFAQ :urlName="item.url" :text="item.question">
                </ListFAQ>
              </div>
            </div>
          </list-group>
          <list-group>
            <h2 class="title-h2">カテゴリから探す<br><span class="title-span">Search by Category</span></h2>
              <div class="category-row">
                <div class="category-col">
                  <div class="categories">
                    <div class="category">
                      <input class="category-input" type="checkbox" id="chck1"> <!-- IDは注意！！ -->
                        <label class="category-label" for="chck1"> <!-- forはIDと一緒にする注意！！ -->
                          <img class="category-icon" src="../assets/images/category_icon/steps.png">
                          <div class="category-label-content">
                            歩数計測
                          </div>
                        </label>
                        <div class="category-content">
                          <ul class="category-content-list">
                            <ListCategory :urlName="'HelpCategory11'" :text="'データと同期処理'"></ListCategory>
                            <ListCategory :urlName="'HelpCategory12'" :text="'ランキング'"></ListCategory>
                            <ListCategory :urlName="'HelpCategory13'" :text="'計測方法の確認／切替え'"></ListCategory>
                          </ul>
                        </div>
                    </div>
                    <div class="category">
                      <input class="category-input" type="checkbox" id="chck2"> <!-- IDは注意！！-->
                        <label class="category-label" for="chck2"> <!-- forはIDと一緒にする注意！！-->
                          <img class="category-icon" src="../assets/images/category_icon/event.png">
                          <div class="category-label-content">
                            オンラインイベント
                          </div>
                        </label>
                        <div class="category-content">
                          <ul class="category-content-list">
                            <ListCategory :urlName="'HelpCategory21'" :text="'イベントの確認／退出'"></ListCategory>
                            <ListCategory :urlName="'HelpCategory22'" :text="'GPSウォーク／ランイベント'"></ListCategory>
                          </ul> 
                        </div>
                    </div>
                    <div class="category">
                      <input class="category-input" type="checkbox" id="chck3"> <!-- IDは注意！！ -->
                        <label class="category-label" for="chck3"> <!-- forはIDと一緒にする注意！！ -->
                          <img class="category-icon" src="../assets/images/category_icon/weband.png">
                          <div class="category-label-content">
                            デバイス
                          </div>
                        </label>
                        <div class="category-content">
                          <ul class="category-content-list">
                            <ListCategory :urlName="'HelpCategory31'" :text="'購入／取扱注意事項'"></ListCategory>
                            <ListCategory :urlName="'HelpCategory32'" :text="'消耗品について'"></ListCategory>
                            <ListCategory :urlName="'HelpCategory33'" :text="'ペアリング/接続する'"></ListCategory>
                            <ListCategory :urlName="'HelpCategory34'" :text="'充電／お手入れ'"></ListCategory>
                            <ListCategory :urlName="'HelpCategory35'" :text="'計測データ'"></ListCategory>
                            <ListCategory :urlName="'HelpCategory36'" :text="'便利機能'"></ListCategory>
                          </ul>
                        </div>
                    </div>
                    <div class="category">
                      <input class="category-input" type="checkbox" id="chck4"> <!-- IDは注意！！ -->
                        <label class="category-label" for="chck4"> <!-- forはIDと一緒にする注意！！ -->
                          <img class="category-icon" src="../assets/images/category_icon/wemile.png">
                          <div class="category-label-content">
                            Weマイル
                          </div>
                        </label>
                        <div class="category-content">
                          <ul class="category-content-list">
                            <ListCategory :urlName="'HelpCategory41'" :text="'マイルを貯める'"></ListCategory>
                            <ListCategory :urlName="'HelpCategory42'" :text="'マイルを使う'"></ListCategory>
                          </ul>
                        </div>
                    </div>
                    <div class="category">
                      <input class="category-input" type="checkbox" id="chck5"> <!-- IDは注意！！ -->
                        <label class="category-label" for="chck5"> <!-- forはIDと一緒にする注意！！ -->
                          <img class="category-icon" src="../assets/images/category_icon/account.png">
                          <div class="category-label-content">
                            アカウント
                          </div>
                        </label>
                        <div class="category-content">
                          <ul class="category-content-list">
                            <ListCategory :urlName="'HelpCategory51'" :text="'登録・ログインする'"></ListCategory>
                            <ListCategory :urlName="'HelpCategory52'" :text="'設定を変更する'"></ListCategory>
                            <ListCategory :urlName="'HelpCategory53'" :text="'プライバシー・セキュリティ'"></ListCategory>
                          </ul> 
                        </div>
                    </div>
                    <div class="category">
                      <input class="category-input" type="checkbox" id="chck6"> <!-- IDは注意！！ -->
                        <label class="category-label" for="chck6"> <!-- forはIDと一緒にする注意！！ -->
                          <img class="category-icon" src="../assets/images/category_icon/important.png">
                          <div class="category-label-content">
                            紛失・アカウント変更・退会
                          </div>
                        </label>
                        <div class="category-content">
                          <ul class="category-content-list">
                            <ListCategory :urlName="'HelpCategory61'" :text="'アカウント（携帯番号/Eメール）を変更する'"></ListCategory>
                            <ListCategory :urlName="'HelpCategory62'" :text="'退会する'"></ListCategory>
                          </ul> 
                        </div>
                    </div>
                    <div class="category">
                      <input class="category-input" type="checkbox" id="chck7"> <!-- IDは注意！！ -->
                        <label class="category-label" for="chck7"> <!-- forはIDと一緒にする注意！！ -->
                          <img class="category-icon" src="../assets/images/category_icon/manager.png">
                          <div class="category-label-content">
                            グループ管理者
                          </div>
                        </label>
                        <div class="category-content">
                          <ul class="category-content-list">
                            <ListCategory :urlName="'HelpCategory71'" :text="'グループ・イベント管理'"></ListCategory>
                          </ul> 
                        </div>
                    </div>
                  </div>
                </div>
              </div>
          </list-group>
        </template>
    </template>
  </page>
</template>

<script>
  import ListGroup from '@/components/ListGroup'
  import ListCategory from '@/components/ListCategory'
  import ListFAQ from '@/components/ListFAQ'
  import Page from '@/components/Page'

  export default {
    name: 'HelpPage',
    components: {
      ListGroup,
      ListCategory,
      ListFAQ,
      Page
    },
    data () {
      return {
        // よくある質問
        faq_items: [
          {
            question: 'WeBand3SCの取り扱い注意事項',
            url: 'Help33'
          },
          {
            question: 'WeBandをペアリングできない',
            url: 'Help9'
          },
          {
            question: '歩数がカウントされない(Android)',
            url: 'Help24'
          },
          {
            question: '歩数が0のまま同期できない(iPhone)',
            url: 'Help2'
          },
          {
            question: 'ﾍﾙｽｹｱに切替えたら歩数がｶｳﾝﾄされなくなった',
            url: 'Help39'
          }
        ]
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../node_modules/hotcss/src/px2rem.scss";
  @import "../assets/style/settings.scss";
  @import "../assets/style/flex.scss";
  @import "../assets/style/faq.scss";

  .padding-top{
    padding-top: 10px;
  }

  .title-h2{
      font-size: 0.65rem;
      color: $color-black-light;
      line-height: 1;
      margin: 2px 0px 10px 10px;
      padding: 0px 0px 0px 10px;
      border-width: 0px 0px 0px 5px;
      border-style: solid;
      border-color: $color-blue-werun;
  }

  .title-span{
      font-size: 0.45rem;
      color: $color-blue-werun;
      font-weight: 400;
  }

</style>


// WEBPACK FOOTER //
// src/pages/HelpList.vue